export default "__VITE_ASSET__BBG7FE4U__"